module.exports = __webpack_public_path__ + "static/media/youtube.a6372485.svg";